import {
	CERTIFICATION_SIGNATURE_TYPE_CODES,
} from "views/Eventos/utils/certification";

export const HEADERS_TABLE_LIST = [
	{ title: "Tipo de firma" },
	{ title: "Nombre visible" },
	{ title: "Campus" },
	{ title: "Vigencia" },
	{ title: "Estado" },
	{ title: "Ver firma" },
	{ title: "Editar" },
	{ title: "Cambiar estado" },
];

export const RECORDS_BY_PAGE = 20;

export const FILTER_STATUS_OPTIONS = [
	{ value: "ALL", text: "Todos" },
	{ value: "ACTIVE", text: "Activos" },
	{ value: "INACTIVE", text: "Inactivos" },
];

export const FILTER_VALIDITY_OPTIONS = [
	{ value: "ALL", text: "Todas" },
	{ value: "CURRENT", text: "Vigentes hoy" },
	{ value: "FUTURE", text: "Futuras" },
	{ value: "EXPIRED", text: "Vencidas" },
	{ value: "INDEFINITE", text: "Indeterminadas" },
];

export const INITIAL_FILTER_FIELDS = {
	campusId: 0,
	signatureTypeCode: "ALL",
	status: "ALL",
	validity: "ALL",
	search: "",
};

export const createEmptySignatureForm = () => ({
	signatureTypeCode: "",
	campusIds: [],
	utpCode: "",
	displayName: "",
	signatureFile: {
		name: "",
		size: 0,
		base64: "",
		contentType: "",
		url: "",
		path: "",
		bucketName: "",
		checksum: "",
		urlExpiresAt: null,
		rawFile: null,
	},
	isIndefiniteValidity: false,
	validFrom: -1,
	validTo: -1,
	isActive: true,
});

export const INITIAL_FORM_ERRORS = {
	signatureTypeCode: false,
	campusIds: false,
	utpCode: false,
	displayName: false,
	signatureFile: false,
	validFrom: false,
	validTo: false,
};

export const EVENT_SIGNATURE_STATUS_LABELS = {
	true: "Activo",
	false: "Inactivo",
};

export const INSTITUTIONAL_SIGNATURE_CODES = [
	CERTIFICATION_SIGNATURE_TYPE_CODES.DGA,
	CERTIFICATION_SIGNATURE_TYPE_CODES.DIRECTOR_CAMPUS,
	CERTIFICATION_SIGNATURE_TYPE_CODES.JEFE_SERVICIO,
];
